<div *ngIf="!hasChoiceQuestionLabels" nz-row [nzJustify]="justify" class="full-height"
	[ngClass]="{'no-flex': layout === 'vertical', 'center-content': showOverviewTemplate}">
	<ng-container *ngIf="showOverviewTemplate">
		<div [ngClass]="{'big-text markdown-html text-center': isWizard, 'font-size-live': !isWizard}">
			<div *ngIf="isWizard">{{ 'workflow.missing_value_in_use' | translate }}</div>
			<div class="centered div-table">
				<workflow-overview-item *ngFor="let config of (questions.overview || groupOverview)"
					[finishedAndLocked]="finishedAndLocked"
					[config]="config"
					[alignTextLeft]="true"
					class="div-table-line"
				></workflow-overview-item>
			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="!showOverviewTemplate && questions.items?.length as length">
		<ng-container *ngFor="let block of questions.items; let index = index">
			<div *ngIf="itemsEnabled && itemsEnabled[index]"
				[appSelectableQuestion]="block.key"
				[appWorkflowItemKey]="blockDataKeys[index]"
				[ngClass]="{'full-height': length === 1}"
			>
				<div nz-col class="flex-column" [ngClass]="{'vertical-flex': layout === 'vertical', 'full-height': layout !== 'vertical'}"
					[nzSpan]="modalView ? 24 : null"
				>
					<div class="block-question-title">
						<span *ngIf="isWizard; else: compactTitle" class="flex-no-grow" [ngClass]="{'large-label': isWizard}" nz-row>{{block.label}}</span>
						<ng-template #compactTitle>
							<span class="flex-no-grow" nz-row>{{block.text}}</span>
						</ng-template>
						<ng-container *ngIf="(block.key | queryState) as state">
							<workflow-query-state *ngIf="state !== 'closed'" [state]="state"></workflow-query-state>
						</ng-container>
					</div>
					<div class="flex-grow" nz-row>
						<span *ngIf="!isWizard && block.label" class="label">{{block.label}}</span>
						<workflow-questionnaire class="flex-grow"
												*ngIf="block.question || questions.default as question"
												[question]="question"
												[isWizard]="isWizard"
												[justify]="justify"
												[finishedAndLocked]="finishedAndLocked"
												[validationLevel]="validationLevel"
												[isLocked]="blockDataWithMissingValue[index] || softLocked || !hasWorkflowWritePermission"
												[isTableDisplay]="false"
												(valid)="setValid($event, index)">
						</workflow-questionnaire>
					</div>
				</div>
			</div>
		</ng-container>
	</ng-container>
</div>

<table *ngIf="hasChoiceQuestionLabels" class="choice-table" [ngClass]="{'full-width': isWizard, 'wizard-table': isWizard}">
	<tbody>
	<ng-container *ngFor="let block of questions.items; let index = index" [appWorkflowItemKey]="block.key">
		<ng-container *ngIf="itemsEnabled && itemsEnabled[index]">
			<tr>
				<td colspan="3" [ngClass]="{'large-label': isWizard}" [hidden]="hideItemText">{{block.text}}</td>
			</tr>
			<tr *ngIf="block.question || questions.default as question" [appSelectableQuestion]="block.key">
				<td *ngIf="firstLabel(question) as label" class="label-left" [ngClass]="{'large-label': isWizard}">
						<span>
							{{ label }}
						</span>
				</td>
				<td class="center-column">
					<span *ngIf="!isWizard && block.label" class="label">{{block.label}}</span>
					<workflow-questionnaire [question]="question"
						[isWizard]="isWizard"
						[justify]="'center'"
						[finishedAndLocked]="finishedAndLocked"
						[validationLevel]="validationLevel"
						[isLocked]="blockDataWithMissingValue[index] || softLocked || !hasWorkflowWritePermission"
						[isTableDisplay]="true"
						(valid)="setValid($event, index)">
					</workflow-questionnaire>
				</td>
				<td *ngIf="lastLabel(question) as label" class="label-right" [ngClass]="{'large-label': isWizard}">
						<span>
							{{ label }}
						</span>
				</td>
			</tr>
		</ng-container>
	</ng-container>
	</tbody>
</table>